"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.some");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.values");

require("core-js/modules/es.string.trim");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * This validator is to guarantee a given address that was free text
 * is not permitted unless the address was selected from the autocomplete
 * or was entered manually. It will test if the unstructured property is present
 * and if all other properties are not present then it is an invalid address.
 * @param message
 * @returns {Function}
 */
var isStructuredAddress = function isStructuredAddress(message) {
  return function (_ref) {
    var field = _ref.field;
    var value = field.value; // This is not an 'isRequired' validator

    if (!field.value) {
      return true;
    } // This is a manual address form
    // Note: this doesn't actually work properly.
    // Toggling manual form on and off will cause the incorrect validation message to show.


    if (!value.id) {
      var _field$extra, _field$extra2;

      var length60Errors = [];
      var length20Errors = [];
      var requiredErrors = []; // Address Line 1 and Address Line 2, Suburb cannot exceed 60 characters

      if (value.addressLine1 && value.addressLine1.length > 60) {
        length60Errors.push('Address Line 1');
      }

      if (value.addressLine2 && value.addressLine2.length > 60) {
        length60Errors.push('Address Line 2');
      }

      if (value.locality && value.locality.length > 60) {
        length60Errors.push('Suburb');
      } // State, Postcode, Country cannot exceed 20 characters


      if (value.province && value.province.length > 20) {
        length20Errors.push('State');
      }

      if (value.postalCode && value.postalCode.length > 20) {
        length20Errors.push('Postcode');
      }

      if (value.country && value.country.length > 20) {
        length20Errors.push('Country');
      }

      if (field === null || field === void 0 ? void 0 : (_field$extra = field.extra) === null || _field$extra === void 0 ? void 0 : _field$extra.required) {
        if (!value.addressLine1) {
          requiredErrors.push('Address Line 1');
        }

        if (!value.country) {
          requiredErrors.push('Country');
        }
      }

      if ((field === null || field === void 0 ? void 0 : (_field$extra2 = field.extra) === null || _field$extra2 === void 0 ? void 0 : _field$extra2.required) && !(value === null || value === void 0 ? void 0 : value.requireOnlyBasicFields)) {
        if (!value.locality) {
          requiredErrors.push('Suburb');
        }

        if (!value.province) {
          requiredErrors.push('State');
        }

        if (!value.postalCode) {
          requiredErrors.push('Postcode');
        }
      } // !IMPORTANT!
      // If you change these messages please also make sure update the way the manual
      // address destructors these messages. It splits the errors intro groups by full stops '.'
      // then splits by commas ',' or 'and' for fields


      var _message = '';

      if (length60Errors.length === 1) {
        _message += "".concat(length60Errors[0], " cannot be more than 60 characters. ");
      } else if (length60Errors.length > 1) {
        var last = length60Errors.pop();
        _message += "".concat(length60Errors.join(', '), " and ").concat(last, " cannot be more than 60 characters. ");
      }

      if (length20Errors.length === 1) {
        _message += "".concat(length20Errors[0], " cannot be more than 20 characters. ");
      } else if (length20Errors.length > 1) {
        var _last = length20Errors.pop();

        _message += "".concat(length20Errors.join(', '), " and ").concat(_last, " cannot be more than 20 characters. ");
      }

      if (requiredErrors.length === 1) {
        _message += "".concat(requiredErrors[0], " is required. ");
      } else if (requiredErrors.length > 1) {
        var _last2 = requiredErrors.pop();

        _message += "".concat(requiredErrors.join(', '), " and ").concat(_last2, " is required. ");
      }

      if (_message.length) {
        return [false, _message.trim()];
      }
    }

    var unstructured = value.unstructured,
        otherProps = _objectWithoutProperties(value, ["unstructured"]);

    if (!unstructured || unstructured.length === 0) {
      return true;
    } // test other properties for valid value


    var hasAnyOtherValue = Object.values(otherProps).some(function (v) {
      return !!v;
    });
    return [hasAnyOtherValue, message];
  };
};

var _default = isStructuredAddress;
exports.default = _default;
//# sourceMappingURL=isStructuredAddress.js.map